// @ts-nocheck
const hostname = window.location.hostname;

// Because originally the absolute path was saved in the db,
// this enhancement was implemented to work with the old images,
// the new images will have to use another utility.

export const getOldCoverImageUrl = (imageUrl = null, preferredSize = null) => {
  if (!imageUrl) {
    return null;
  }

  const allowedSizes = ['BL', 'TH', 'SM', 'MD', 'LG'];
  const normalizedPreferredSize = preferredSize
    ? String(preferredSize).toUpperCase()
    : null;
  const shouldReplaceSizePrefix =
    normalizedPreferredSize && allowedSizes.includes(normalizedPreferredSize);

  const applyPreferredSize = (url) => {
    if (!shouldReplaceSizePrefix || !url) {
      return url;
    }

    const lastSlashIndex = url.lastIndexOf('/');
    const basePath =
      lastSlashIndex >= 0 ? url.slice(0, lastSlashIndex + 1) : '';
    const filename = lastSlashIndex >= 0 ? url.slice(lastSlashIndex + 1) : url;

    const updatedFilename = filename.replace(
      /^(BL|TH|SM|MD|LG)-/,
      `${normalizedPreferredSize}-`
    );

    return `${basePath}${updatedFilename}`;
  };

  const isAbsoluteUrl = /^https?:\/\//i.test(imageUrl);
  const isDataUrl = imageUrl.startsWith('data:');
  const isBlobUrl = imageUrl.startsWith('blob:');

  if (isAbsoluteUrl || isDataUrl || isBlobUrl) {
    return isDataUrl || isBlobUrl ? imageUrl : applyPreferredSize(imageUrl);
  }

  if (hostname === 'dev.softrip.com') {
    return applyPreferredSize(imageUrl);
  }

  // If the path starts with /, it's already a relative path - use as-is
  // This handles new imageUploadBE paths and any other relative paths
  if (imageUrl.startsWith('/')) {
    return applyPreferredSize(imageUrl);
  }

  const lastSegment = imageUrl.split('/').pop();
  const updatedLastSegment = applyPreferredSize(lastSegment);

  return updatedLastSegment ? `/images/${updatedLastSegment}` : imageUrl;
};

// Here you can create the utility to generate the path to access
// the images with the new file upload service.
